import { useMutation } from 'react-query';
import request from '../../../helpers/request';

const getOrgsByInn = async (value) => {
  return await request.get(
    `/Docs/orgs_by_inn/${value}`,
    null,
    'При получении организаций произошла ошибка',
    'Error'
  );
};

const useOrgsByInn = () => {
  // const queryClient = useQueryClient();

  const mutation = useMutation(getOrgsByInn, {
    onSuccess: async (data) => {
      if (data === 'Error') return;
      if (data.success) {
      }
    },
  });

  return {
    isLoading: mutation.isLoading,
    getOrgsByInn: mutation.mutateAsync,
  };
};

export default useOrgsByInn;
